<template>
    <div>
        <div class="bg-white border p-4 md:p-8 flex flex-col md:flex-row md:flex-wrap justify-between">
            <Input :error="errors['customer.first_name']" class="basis" idAttr="first_name" :label="translations.first_name" :placeholder="translations.first_name" v-model="form.first_name" />
            <Input :error="errors['customer.last_name']" class="basis" idAttr="last_name" :label="translations.last_name" :placeholder="translations.last_name" v-model="form.last_name" />
            <Input :error="errors['customer.email']" class="basis pt-3" idAttr="email" :label="translations.email_address" :placeholder="translations.email_address" v-model="form.email" />
            <Input :error="errors['customer.zipcode']" class="basis pt-3" idAttr="zipcode" :label="translations.zipcode" :placeholder="translations.zipcode" v-model="form.zipcode" />
            <Input :error="errors['customer.address1']" class="basis pt-3" idAttr="address" :label="translations.address" :placeholder="translations.address" v-model="form.address1" />
            <Input :error="errors['customer.city']" class="basis pt-3" idAttr="city" :label="translations.city" :placeholder="translations.city" v-model="form.city" />
            <Input :error="errors['customer.phone']" class="basis pt-3 mt-auto" idAttr="phone_number" :label="translations.phone_number" :placeholder="translations.phone_number" v-model="form.phone" />
            <!-- <Input :error="errors['customer.packages']" class="basis pt-3" idAttr="packages" :label="translations.packages" :placeholder="translations.packages" v-model="form.packages" /> -->
            <div class="flex flex-col basis pt-3" v-if="isReturn">
                <label for="packages" class="pb-3 uppercase text-base font-medium">{{translations.packages}}</label>
                <select class="border disabled:opacity-80 input" v-model="form.packages" id="packages" name="packages">
                    <option v-for="count in [1,2,3,4,5,6,7,8,9]" :value="count">{{ count }}</option>
                </select>
             </div>
        </div>
        <div>
            <div class="mt-8 md:mt-10 px-4 md:p-0">
                <p v-if="form.customerCountryIsBlocked" class="2" v-html="translations.information_self_service"></p>
                <p v-if="form.informative_order_shopped_during_campaign" class="3" v-html="translations.informative_order_shopped_during_campaign"></p>
            </div>
        </div>
        <div class="flex mt-8 md:mt-12 flex-col mx-4 md:mx-0">
            <Button :disabled="!canRegister" :text="translations.register_my_return" class="mb-6" @click="show = true"/>
            <ButtonWhite :text="translations.back" @click="$emit('back')" />
        </div>
        <Modal :show="show" @close="show = false">
            <div class="flex flex-col">
                <h1 class="text-center">{{ translations.confirm_my_return_title }}</h1>
                <p class="text-center">{{ translations.confirm_my_return_message }}</p>
                <div class="flex mt-10 flex-col">
                    <Button :text="translations.confirm_my_return_yes" @click="submit()" class="mb-6"/>
                    <ButtonWhite :text="translations.back" @click="show = false" />
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/Components/Modal'
export default {
    components: {
        Modal,
    },
    props: {
        translations: Object, errors: Array|Object, customerDetails: Object, isReturn: Boolean
    },
    data() {
        return {
            show: false,
            form: {
                'packages': 1,
                'city': this.customerDetails.city,
                'email': this.customerDetails.email,
                'zipcode': this.customerDetails.zipcode,
                'address1': this.customerDetails.address1,
                'first_name': this.customerDetails.first_name,
                'last_name': this.customerDetails.last_name,
                'phone': this.customerDetails.phone_number,
                'customerCountryIsBlocked': this.customerDetails.isSelfService,
                'informative_order_shopped_during_campaign': this.customerDetails.isCampaign,
            }
        }
    },
    computed: {
        canRegister() {
            return this.form.packages >= 1
                && this.form.city
                && this.form.email
                && this.form.zipcode
                && this.form.address1
                && this.form.first_name
                && this.form.last_name
                && this.form.phone
        }
    },
    methods: {
        async submit() {
            this.show = false
            this.$emit('submitErrand', this.form)
        }
    }
}
</script>

<style lang="scss" scoped>
.basis {
    flex-basis: 48%;
}

svg {
    width:40px;
}
</style>
